export default "__VITE_ASSET__d6a35e93__"